import { clear, get, set } from 'src/core/classes/helpers/StorageHelper'
import VersionStoreService from 'src/core/classes/services/VersionStoreService'

interface ICacheData {
  data: any
  apiVersion?: number
}

// When you simply fetch data, you should use "skipIncrement = true" parameter,
// But actually if you change/update/create any data and save it to cache you
// should use "skipIncrement = false" for update current data version

const saveToCache = async (cacheKey: string, data: any, skipIncrement: boolean = false) => {
  let apiVersion: number = 0
  if (skipIncrement) {
    const fetchedVersion = VersionStoreService.getApiVersionByKey(cacheKey)
    if (fetchedVersion) {
      apiVersion = fetchedVersion.version
    } else {
      apiVersion = await VersionStoreService.updateApiVersion(cacheKey)
    }
  } else {
    apiVersion = await VersionStoreService.updateApiVersion(cacheKey)
  }
  return set(cacheKey, JSON.stringify({ data, apiVersion }))
}

const readFromCache = (cacheKey: string) => {
  if (!checkCache(cacheKey)) {
    return JSON.parse(get(cacheKey) || '{}').data
  }
  return null
}

const checkCache = (key: string): boolean => {
  const cache = get(key)
  if (cache) {
    const cacheObject = JSON.parse(cache) as ICacheData
    return VersionStoreService.checkApiVersion(key, cacheObject.apiVersion || 0)
  }
  return true
}

export { saveToCache, readFromCache, checkCache, clear }
